__turbopack_context__.v({
  "dot": "_4Yl36a_dot",
  "error": "_4Yl36a_error",
  "info": "_4Yl36a_info",
  "label": "_4Yl36a_label",
  "lg": "_4Yl36a_lg",
  "md": "_4Yl36a_md",
  "neutral": "_4Yl36a_neutral",
  "pulse": "_4Yl36a_pulse",
  "root": "_4Yl36a_root",
  "sm": "_4Yl36a_sm",
  "srOnly": "_4Yl36a_srOnly",
  "statusdot-pulse": "_4Yl36a_statusdot-pulse",
  "success": "_4Yl36a_success",
  "warning": "_4Yl36a_warning",
});
